import z from "zod";
import { ZodDateString } from "../../zod-types/zod-date-string";

export const getScheduledTicketsQuerySchema = z.object({
	startDate: ZodDateString,
	endDate: ZodDateString,
});

export type GetScheduledTicketsQuerySchema = z.infer<typeof getScheduledTicketsQuerySchema>;
